import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  FieldExtensionComponentProps,
  createScaffolderFieldExtension,
} from '@backstage/plugin-scaffolder-react'; // eslint-disable-line
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios'; // eslint-disable-line
import { useAsync } from 'react-use';

export const TeamcityBuildTemplatesSchema = {
  uiOptions: {},
  returnValue: { type: 'string' },
};

type TeamcityBuildTemplate = {
  id: string;
  name: string;
  templateFlag: boolean;
  projectName: string;
  projectId: string;
  href: string;
};

export const TeamcityBuildTemplates = ({
  onChange,
}: FieldExtensionComponentProps<string, {}>) => {
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const baseURL = `${configApi.getString(
    'backend.baseUrl',
  )}/api/proxy/teamcity-proxy/app/rest/buildTypes/?locator=templateFlag:true,project:_Root`;

  const { value, loading, error } = useAsync(async () => {
    const { token } = await identityApi.getCredentials();
    const response = await axios({
      url: baseURL,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.status !== 200) {
      throw new Error('Failed to fetch Teamcity Build configuration templates');
    }
    const data = await response.data;
    return data.buildType;
  }, []);

  if (loading) return <div>loading</div>;
  if (error) return <div>error: {error.message}</div>;
  return (
    <FormControl>
      <Autocomplete
        id="teamcity-buildProjects"
        options={value}
        getOptionLabel={(template: TeamcityBuildTemplate) => template.name}
        renderInput={params => (
          <TextField
            {...params}
            label="Teamcity Build Config"
            variant="outlined"
          />
        )}
        onChange={(_event, template: TeamcityBuildTemplate | null) =>
          template ? onChange(template.id) : onChange('')
        }
      />
    </FormControl>
  );
};

export const TeamcityBuildTemplatesExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'TeamcityBuildTemplates',
    component: TeamcityBuildTemplates,
  }),
);
